import '@angular/compiler'; // Keep this for dynamic component loading
import { enableProdMode } from '@angular/core';
import { environment } from './environments/environment';
import { bootstrapApp } from 'bootstrap-app';
// import { bootstrapApp } from './app/bootstrap-app';

if (environment.production) {
  enableProdMode();
}

function bootstrap() {
  bootstrapApp().catch(err => console.error('Bootstrap error:', err));
}

if (document.readyState === 'complete') {
  bootstrap();
} else {
  document.addEventListener('DOMContentLoaded', bootstrap);
}
